/**
 * The currencies a payout can be issued in. Mirrors SUPPORTED_CURRENCIES and DEFAULT_CURRENCY in
 * app/money/ledger/money.py; tests/money/ledger/test_money.py fails when the two drift apart.
 */
export const SUPPORTED_CURRENCIES = [
  "EUR",
  "GBP",
  "SEK",
  "NOK",
  "DKK",
  "PLN",
  "CHF",
  "USD",
] as const;

export type Currency = (typeof SUPPORTED_CURRENCIES)[number];

export const DEFAULT_CURRENCY: Currency = "EUR";
